import { render, staticRenderFns } from "./PatientSurgeryStaff.vue?vue&type=template&id=452fd8ae&scoped=true"
import script from "./PatientSurgeryStaff.vue?vue&type=script&lang=js"
export * from "./PatientSurgeryStaff.vue?vue&type=script&lang=js"
import style0 from "./PatientSurgeryStaff.vue?vue&type=style&index=0&id=452fd8ae&prod&scoped=true&lang=css"
import style1 from "./PatientSurgeryStaff.vue?vue&type=style&index=1&id=452fd8ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452fd8ae",
  null
  
)

export default component.exports